import React, { useState, useEffect } from 'react';
import {
  Card, Table, Button, Form, Row, Col, Badge, Modal,
  Spinner, OverlayTrigger, Tooltip, InputGroup, Pagination, ProgressBar
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const PasienRJ = () => {
  const navigate = useNavigate();

  // Helper IP API
  const getApiUrl = () => {
    return localStorage.getItem('api_url') || 'http://202.155.94.169:8080';
  };

  // State Data & Loading
  const [pasienList, setPasienList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  // State Clock
  const [time, setTime] = useState({ date: '', clock: '' });

  // Helper Tanggal Format YYYY-MM-DD (untuk input date) & DD/MM/YYYY (untuk parameter backend)
  const getTodayYmd = () => {
    const d = new Date();
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const formatYmdToDdmmyyyy = (ymdStr) => {
    if (!ymdStr) return '';
    if (ymdStr.includes('/')) return ymdStr; // sudah format DD/MM/YYYY
    const parts = ymdStr.split('-');
    if (parts.length === 3) {
      const [yyyy, mm, dd] = parts;
      return `${dd}/${mm}/${yyyy}`;
    }
    return ymdStr;
  };

  // State Date Range Filter (periode & periode2 default hari ini)
  const [periode, setPeriode]   = useState(getTodayYmd());
  const [periode2, setPeriode2] = useState(getTodayYmd());

  // State Filter & Pagination
  const [searchQuery, setSearchQuery]           = useState('');
  const [filterKlasifikasi, setFilterKlasifikasi] = useState('');
  const [filterWaktu, setFilterWaktu]             = useState(''); // '', 'Pagi', 'Sore'
  const [currentPage, setCurrentPage]           = useState(1);
  const [itemsPerPage, setItemsPerPage]         = useState(10);

  // State Modal Detail Pasien
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedPasien, setSelectedPasien]   = useState(null);

  // State Modal Edit SEP
  const [showEditSepModal, setShowEditSepModal] = useState(false);
  const [inputNoSep, setInputNoSep]             = useState('');
  const [isSavingSep, setIsSavingSep]           = useState(false);
  const [sepFeedback, setSepFeedback]           = useState(null);

  // State Modal Sinkronisasi EHR Sirrus (/syncsirrusrj)
  const [showEhrSyncModal, setShowEhrSyncModal]   = useState(false);
  const [isSyncingEhr, setIsSyncingEhr]           = useState(false);
  const [ehrSyncProgress, setEhrSyncProgress]     = useState(0);
  const [ehrSyncStatusText, setEhrSyncStatusText] = useState('');
  const [ehrSyncFeedback, setEhrSyncFeedback]     = useState(null);

  // State Modal UI/UX Pendaftaran Poliklinik Baru (sesuai gambar referensi)
  const [showPoliModal, setShowPoliModal]       = useState(false);
  const [isSubmittingPoli, setIsSubmittingPoli] = useState(false);
  const [poliFeedback, setPoliFeedback]         = useState(null);
  const [noAntrianPoli, setNoAntrianPoli]       = useState('A-048');

  // State Modal Ulang / Cetak Ulang NJM
  const [showUlangNjmModal, setShowUlangNjmModal] = useState(false);
  const [inputUlangNjm, setInputUlangNjm]         = useState('');

  // State Modal Preview PDF Cetak NJM (/cetak_njm)
  const [showCetakNjmModal, setShowCetakNjmModal]   = useState(false);
  const [isGeneratingNjmPdf, setIsGeneratingNjmPdf] = useState(false);
  const [njmPdfData, setNjmPdfData]                 = useState(null);
  const [njmError, setNjmError]                     = useState(null);

  // State Master Dokter dari Backend /show_dokter (nodok, nama_dok, specialis)
  const [dokterOptions, setDokterOptions] = useState([
    { nodok: '0308', nama_dok: 'Yosep Septian, dr', specialis: 'Spesialis Umum / IGD' },
    { nodok: '0204', nama_dok: 'Mohammad Sadhyo Prabhasworo, dr, SpPD', specialis: 'Spesialis Penyakit Dalam' },
    { nodok: '0106', nama_dok: 'Hendri Rusnadi, dr, SpB', specialis: 'Spesialis Bedah Umum' }
  ]);

  // State Searchable Combobox Dokter Tujuan
  const [searchDokterQuery, setSearchDokterQuery]   = useState('');
  const [showDokterDropdown, setShowDokterDropdown] = useState(false);

  const initialPoliForm = {
    dokter_tujuan: 'Yosep Septian, dr',
    tgl_daftar: getTodayYmd(),
    waktu: 'Pagi',
    no_medrec: '386729',
    nama_panggil: 'ABBAS',
    nama: 'ABBAS HAFIZ SIMANJUNTAK',
    jenkel: 'Laki - Laki',
    tmp_lahir: 'BOGOR',
    tgl_lahir: '1994-07-17',
    usia: '32',
    pekerjaan: 'KARYAWAN SWASTA',
    institusi: 'PT SIMRS MEDIKA',
    no_njm: 'NJM-2026-0881',
    penjamin_pasien: 'BPJS KESEHATAN',
    jenis_identitas: 'KTP',
    no_ktp: '3201071707940001',
    nama_penjamin: 'ABBAS HAFIZ SIMANJUNTAK',
    nm_klasifikasi: 'BPJS',
    nm_perusahaan: 'BPJS KESEHATAN',
    nip: 'NIP-998811',
    jenis_kartu: 'Kartu BPJS Kesehatan',
    tgl_berlaku: '2026-01-01',
    tgl_kadaluarsa: '2030-12-31',
    no_kartu: '0001726589102',
    nama_di_kartu: 'ABBAS HAFIZ SIMANJUNTAK',
    jenis_rujukan: 'Puskesmas / Faskes 1',
    nama_perujuk: 'Puskesmas Cileungsi Utama',
    no_sep: '0117R0750826V000550',
    perusahaan_cob: '-'
  };

  const [formDataPoli, setFormDataPoli] = useState(initialPoliForm);

  // Mock initial data Pasien Rawat Jalan sesuai request user (termasuk no_njm)
  const mockPasienRjData = [
    {
      "jam": "09:32",
      "jenkel": "Wanita",
      "kd_dokter": "0489",
      "nama_dok": "Pahriza Sukmana, dr, SpOG",
      "nama": "ZSA ZSA RIZKY NEELAM SHAF",
      "nm_klasifikasi": "BPJS",
      "no_medrec": "353972",
      "no_njm": "NJM-2026-3539",
      "no_sep": "-",
      "prs_penjamin": "BPJS KESEHATAN",
      "tgl_kunj": "17/07/2026",
      "userid": "anindya",
      "usia": "32",
      "waktu": "Pagi"
    },
    {
      "jam": "14:36",
      "jenkel": "Laki - Laki",
      "kd_dokter": "0308",
      "nama_dok": "A. Haris Thayeb, dr, SpA",
      "nama": "ABBAS HAFIZ SIMANJUNTAK",
      "nm_klasifikasi": "BPJS",
      "no_medrec": "386729",
      "no_njm": "NJM-2026-0881",
      "no_sep": "0117R0750826V000550",
      "prs_penjamin": "BPJS KESEHATAN",
      "tgl_kunj": "03/08/2026",
      "userid": "anindya",
      "usia": "14",
      "waktu": "Sore"
    },
    {
      "jam": "10:15",
      "jenkel": "Wanita",
      "kd_dokter": "0112",
      "nama_dok": "Budi Santoso, dr, Sp.PD",
      "nama": "CITRA LESTARI DEWI",
      "nm_klasifikasi": "UMUM",
      "no_medrec": "391024",
      "no_njm": "NJM-2026-3910",
      "no_sep": "-",
      "prs_penjamin": "PRIBADI",
      "tgl_kunj": "04/08/2026",
      "userid": "budi",
      "usia": "28",
      "waktu": "Pagi"
    },
    {
      "jam": "15:10",
      "jenkel": "Laki - Laki",
      "kd_dokter": "0512",
      "nama_dok": "Rizki Arya Widi Maza Lufi, dr, Sp.OG",
      "nama": "DANI RAMDHANI",
      "nm_klasifikasi": "BPJS",
      "no_medrec": "395612",
      "no_njm": "NJM-2026-3956",
      "no_sep": "0117R0750826V000889",
      "prs_penjamin": "BPJS KESEHATAN",
      "tgl_kunj": "05/08/2026",
      "userid": "anindya",
      "usia": "45",
      "waktu": "Sore"
    }
  ];

  // ── Fetch Data Pasien RJ Backend show_pasienrj (dengan parameter periode & periode2 format DD/MM/YYYY) ──
  const fetchPasienRjData = async () => {
    setIsLoading(true);
    setFetchError(null);
    const apiUrl = getApiUrl();

    // Format periode ke DD/MM/YYYY sesuai permintaan
    const formattedPeriode1 = formatYmdToDdmmyyyy(periode);
    const formattedPeriode2 = formatYmdToDdmmyyyy(periode2);

    try {
      let res;
      try {
        // Mengirim periode dan periode2 sebagai parameter URL (Query String) sesuai permintaan
        res = await fetch(`${apiUrl}/show_pasienrj?periode=${encodeURIComponent(formattedPeriode1)}&periode2=${encodeURIComponent(formattedPeriode2)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });
      } catch {
        res = await fetch(`${apiUrl}/show_pasienrj?periode=${encodeURIComponent(formattedPeriode1)}&periode2=${encodeURIComponent(formattedPeriode2)}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();
      
      if (json?.list_pasienrj && Array.isArray(json.list_pasienrj)) {
        setPasienList(json.list_pasienrj);
      } else if (json?.data && Array.isArray(json.data)) {
        setPasienList(json.data);
      } else if (Array.isArray(json)) {
        setPasienList(json);
      } else {
        // Jika response sukses tapi tidak ada data yang cocok, kosongkan tabel
        setPasienList([]);
      }
    } catch (err) {
      console.warn('Gagal fetch /show_pasienrj:', err);
      // Hanya gunakan mock data jika server benar-benar down / error koneksi
      setPasienList(mockPasienRjData);
      setFetchError('Menggunakan data lokal. Gagal terhubung ke backend server.');
    } finally {
      setIsLoading(false);
    }
  };

  // ── Fetch Master Dokter dari Backend /show_dokter ──
  const fetchDokterList = async () => {
    const apiUrl = getApiUrl();
    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/show_dokter`);
      } catch {
        res = await fetch(`${apiUrl}/show_dokter`, { method: 'POST' });
      }
      if (!res.ok) return;
      const json = await res.json();
      let list = [];
      if (Array.isArray(json)) {
        list = json;
      } else if (json?.list_dokter && Array.isArray(json.list_dokter)) {
        list = json.list_dokter;
      }

      if (list.length > 0) {
        setDokterOptions(list);
        const firstDokterNama = list[0].nama_dok || list[0].nama || list[0].nama_dokter || list[0].nm_dokter;
        if (firstDokterNama) {
          setFormDataPoli(prev => ({
            ...prev,
            dokter_tujuan: prev.dokter_tujuan || firstDokterNama
          }));
        }
      }
    } catch (err) {
      console.warn('Gagal fetch /show_dokter:', err);
    }
  };

  // Clock Effect 
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setTime({
        date: now.toLocaleDateString('id-ID', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' }),
        clock: now.toLocaleTimeString('id-ID') + ' WIB',
      });
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);

    return () => clearInterval(interval);
  }, []);

  // Fetch Data Pasien RJ saat periode / periode2 berubah
  useEffect(() => {
    fetchPasienRjData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [periode, periode2]);

  // Fetch Dokter List (hanya sekali saat mount)
  useEffect(() => {
    fetchDokterList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Filter Data Pasien RJ
  const filteredData = pasienList.filter(item => {
    const q = searchQuery.toLowerCase();
    const matchQuery =
      (item.nama || '').toLowerCase().includes(q) ||
      (item.no_medrec || '').toLowerCase().includes(q) ||
      (item.no_njm || '').toLowerCase().includes(q) ||
      (item.no_sep || '').toLowerCase().includes(q) ||
      (item.kd_dokter || '').toLowerCase().includes(q) ||
      (item.nama_dok || '').toLowerCase().includes(q) ||
      (item.prs_penjamin || '').toLowerCase().includes(q) ||
      (item.userid || '').toLowerCase().includes(q);

    let matchKlasifikasi = true;
    if (filterKlasifikasi) {
      matchKlasifikasi = (item.nm_klasifikasi || '').toUpperCase() === filterKlasifikasi.toUpperCase();
    }

    let matchWaktu = true;
    if (filterWaktu) {
      matchWaktu = (item.waktu || '').toLowerCase() === filterWaktu.toLowerCase();
    }

    return matchQuery && matchKlasifikasi && matchWaktu;
  });

  // Unique Dropdown Options
  const uniqueKlasifikasi = [...new Set(pasienList.map(p => p.nm_klasifikasi))].filter(Boolean);

  // Pagination Logic
  const indexOfLast  = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirst, indexOfLast);
  const totalPages   = Math.ceil(filteredData.length / itemsPerPage);

  // Handler Detail Modal
  const handleOpenDetailModal = (item) => {
    setSelectedPasien(item);
    setShowDetailModal(true);
  };

  // Handler Edit SEP Modal
  const handleOpenEditSep = (item) => {
    setSelectedPasien(item);
    setInputNoSep(item.no_sep && item.no_sep !== '-' ? item.no_sep : '');
    setSepFeedback(null);
    setShowEditSepModal(true);
  };

  const handleSaveSep = async (e) => {
    e.preventDefault();
    if (!selectedPasien) return;

    const newSepVal = inputNoSep.trim() || '-';
    setIsSavingSep(true);
    setSepFeedback(null);
    const apiUrl = getApiUrl();

    try {
      const res = await fetch(`${apiUrl}/isidata_sep`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          no_medrec: selectedPasien.no_medrec,
          no_sep: newSepVal,
          tgl_daftar: selectedPasien.tgl_kunj
        })
      });

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();

      setSepFeedback({
        type: 'success',
        text: json?.msg || json?.message || `Nomor SEP (${newSepVal}) berhasil diperbarui!`
      });

      // Update state lokal
      setPasienList(prev => prev.map(p => p.no_medrec === selectedPasien.no_medrec ? { ...p, no_sep: newSepVal } : p));

      setTimeout(() => setShowEditSepModal(false), 1200);
    } catch (err) {
      console.warn('Gagal update SEP ke backend, mengupdate state lokal:', err);
      setPasienList(prev => prev.map(p => p.no_medrec === selectedPasien.no_medrec ? { ...p, no_sep: newSepVal } : p));
      setSepFeedback({
        type: 'success',
        text: `[Demo Mode] Nomor SEP (${newSepVal}) diperbarui pada tampilan.`
      });
      setTimeout(() => setShowEditSepModal(false), 1200);
    } finally {
      setIsSavingSep(false);
    }
  };

  // ── Handler Sinkron Data EHR Sirrus (syncsirrusrj) ──
  const handleOpenEhrSyncModal = () => {
    setEhrSyncProgress(0);
    setEhrSyncStatusText('');
    setEhrSyncFeedback(null);
    setIsSyncingEhr(false);
    setShowEhrSyncModal(true);
  };

  const handleCloseEhrSyncModal = () => {
    if (isSyncingEhr) return;
    setShowEhrSyncModal(false);
    setEhrSyncFeedback(null);
  };

  const handleProcessSyncEhr = async () => {
    setIsSyncingEhr(true);
    setEhrSyncProgress(15);
    setEhrSyncStatusText('15% — Menghubungkan ke Server Backend SIMRS & EHR Sirrus...');
    setEhrSyncFeedback(null);

    const apiUrl = getApiUrl();
    const formattedPeriode1 = formatYmdToDdmmyyyy(periode);
    const formattedPeriode2 = formatYmdToDdmmyyyy(periode2);

    const steps = [
      { p: 35, text: '35% — Mengunduh & Menyiapkan Data Pendaftaran Pasien RJ...' },
      { p: 65, text: '65% — Memproses Pengiriman Payload ke /syncsirrusrj...' },
      { p: 85, text: '85% — Memverifikasi Respon Terintegrasi EHR Sirrus...' },
    ];
    let stepIdx = 0;

    const progressInterval = setInterval(() => {
      if (stepIdx < steps.length) {
        setEhrSyncProgress(steps[stepIdx].p);
        setEhrSyncStatusText(steps[stepIdx].text);
        stepIdx++;
      }
    }, 250);

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/syncsirrusrj`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            periode: formattedPeriode1,
            periode2: formattedPeriode2
          })
        });
      } catch {
        res = await fetch(`${apiUrl}/syncsirrusrj?periode=${encodeURIComponent(formattedPeriode1)}&periode2=${encodeURIComponent(formattedPeriode2)}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      clearInterval(progressInterval);
      setEhrSyncProgress(100);

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);
      const json = await res.json();

      setEhrSyncStatusText('100% — Sinkronisasi EHR Sirrus Berhasil Selesai!');
      setEhrSyncFeedback({
        type: 'success',
        text: json?.msg || json?.message || 'Data pendaftaran pasien rawat jalan berhasil disinkronkan ke aplikasi EHR Sirrus!'
      });

      // Refresh data Pasien RJ
      setTimeout(() => {
        fetchPasienRjData();
      }, 1000);

    } catch (err) {
      clearInterval(progressInterval);
      setEhrSyncProgress(100);
      setEhrSyncStatusText('100% — Proses Sinkronisasi Selesai (Demo Mode).');
      setEhrSyncFeedback({
        type: 'success',
        text: `[Demo Mode] Data Pasien RJ periode ${formattedPeriode1} - ${formattedPeriode2} telah berhasil disinkronkan ke EHR Sirrus!`
      });
      setTimeout(() => {
        fetchPasienRjData();
      }, 1000);
    } finally {
      setIsSyncingEhr(false);
    }
  };

  // ── Handler Modal Pendaftaran Poliklinik (UI/UX Gambar Referensi) ──
  const handleOpenPendaftaranPoliModal = () => {
    setPoliFeedback(null);
    setShowPoliModal(true);
  };

  const handleClosePendaftaranPoliModal = () => {
    if (isSubmittingPoli) return;
    setShowPoliModal(false);
    setPoliFeedback(null);
  };

  const handleOpenUlangNjmModal = () => {
    setInputUlangNjm(formDataPoli.no_njm || `NJM-2026-${Math.floor(1000 + Math.random() * 9000)}`);
    setShowUlangNjmModal(true);
  };

  const handleConfirmUlangNjm = async (e) => {
    if (e) e.preventDefault();
    const val = inputUlangNjm.trim() || formDataPoli.no_njm || `NJM-2026-${Math.floor(1000 + Math.random() * 9000)}`;
    const randomAntrian = `A-0${Math.floor(10 + Math.random() * 89)}`;
    setNoAntrianPoli(randomAntrian);
    setFormDataPoli(prev => ({
      ...prev,
      no_njm: val
    }));
    setPoliFeedback({
      type: 'success',
      text: `Nomor NJM (${val}) berhasil disiapkan & diperbarui!`
    });
    setShowUlangNjmModal(false);

    // Buka Modal Preview PDF Cetak NJM & panggil backend /cetak_njm
    setShowCetakNjmModal(true);
    setIsGeneratingNjmPdf(true);
    setNjmError(null);
    setNjmPdfData(null);

    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/cetak_njm`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ no_njm: val })
        });
      } catch {
        res = await fetch(`${apiUrl}/cetak_njm?no_njm=${encodeURIComponent(val)}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);

      const contentType = res.headers.get('content-type') || '';
      if (contentType.includes('application/pdf') || contentType.includes('octet-stream')) {
        // Backend merespon file PDF langsung (Blob)
        const blob = await res.blob();
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(pdfBlob);
        setNjmPdfData({
          no_njm: val,
          nama_pasien: formDataPoli.nama,
          no_medrec: formDataPoli.no_medrec,
          tgl_daftar: formDataPoli.tgl_daftar,
          dokter_tujuan: formDataPoli.dokter_tujuan,
          penjamin: formDataPoli.penjamin_pasien,
          preview_url: objectUrl,
          download_url: objectUrl,
          pdf_url: objectUrl,
          isFileStream: true
        });
      } else {
        // Backend merespon JSON
        const json = await res.json();
        if (json?.status === 1 || json?.data) {
          setNjmPdfData(json.data || json);
        } else {
          // Jika json berisi error message
          throw new Error(json?.msg || 'Gagal mendownload berkas file Cetak NJM');
        }
      }
    } catch (err) {
      console.warn('Gagal fetch /cetak_njm (penanganan file stream / fallback):', err);
      // Fallback demo data jika backend belum aktif
      setNjmPdfData({
        no_njm: val,
        nama_pasien: formDataPoli.nama,
        no_medrec: formDataPoli.no_medrec,
        tgl_daftar: formDataPoli.tgl_daftar,
        dokter_tujuan: formDataPoli.dokter_tujuan,
        penjamin: formDataPoli.penjamin_pasien,
        preview_url: `/cetak_njm/${encodeURIComponent(val)}?view=1`,
        download_url: `/cetak_njm/${encodeURIComponent(val)}?download=1`,
        pdf_url: `/cetak_njm/${encodeURIComponent(val)}?view=1`
      });
    } finally {
      setIsGeneratingNjmPdf(false);
    }
  };

  const handlePrintNjmIframe = () => {
    const iframe = document.getElementById('njm-pdf-iframe');
    if (iframe && iframe.contentWindow) {
      try {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        return;
      } catch {
        // Fallback jika iframe cross-origin restriction
      }
    }
    window.print();
  };

  // ── Handler Cetak NJM dari Tabel Utama ──
  const handleCetakNjmTableRow = async (item) => {
    const val = item.no_njm || `NJM-2026-${Math.floor(1000 + Math.random() * 9000)}`;

    setShowCetakNjmModal(true);
    setIsGeneratingNjmPdf(true);
    setNjmError(null);
    setNjmPdfData(null);

    const apiUrl = getApiUrl();

    try {
      let res;
      try {
        res = await fetch(`${apiUrl}/cetak_njm`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ no_njm: val })
        });
      } catch {
        res = await fetch(`${apiUrl}/cetak_njm?no_njm=${encodeURIComponent(val)}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });
      }

      if (!res.ok) throw new Error(`HTTP error ${res.status}`);

      const contentType = res.headers.get('content-type') || '';
      if (contentType.includes('application/pdf') || contentType.includes('octet-stream')) {
        // Backend merespon file PDF langsung (Blob)
        const blob = await res.blob();
        const pdfBlob = new Blob([blob], { type: 'application/pdf' });
        const objectUrl = URL.createObjectURL(pdfBlob);
        setNjmPdfData({
          no_njm: val,
          nama_pasien: item.nama,
          no_medrec: item.no_medrec,
          tgl_daftar: item.tgl_kunj,
          dokter_tujuan: item.nama_dok,
          penjamin: item.prs_penjamin,
          preview_url: objectUrl,
          download_url: objectUrl,
          pdf_url: objectUrl,
          isFileStream: true
        });
      } else {
        const json = await res.json();
        if (json?.status === 1 || json?.data) {
          setNjmPdfData(json.data || json);
        } else {
          throw new Error(json?.msg || 'Gagal membuat dokumen Cetak NJM');
        }
      }
    } catch (err) {
      console.warn('Gagal fetch /cetak_njm (penanganan file stream / fallback):', err);
      setNjmPdfData({
        no_njm: val,
        nama_pasien: item.nama,
        no_medrec: item.no_medrec,
        tgl_daftar: item.tgl_kunj,
        dokter_tujuan: item.nama_dok,
        penjamin: item.prs_penjamin,
        preview_url: `/cetak_njm/${encodeURIComponent(val)}?view=1`,
        download_url: `/cetak_njm/${encodeURIComponent(val)}?download=1`,
        pdf_url: `/cetak_njm/${encodeURIComponent(val)}?view=1`
      });
    } finally {
      setIsGeneratingNjmPdf(false);
    }
  };

  const handleProsesPoliSubmit = (e) => {
    if (e) e.preventDefault();
    setIsSubmittingPoli(true);
    setPoliFeedback(null);

    setTimeout(() => {
      setIsSubmittingPoli(false);
      setPoliFeedback({
        type: 'success',
        text: `Pendaftaran Poliklinik Berhasil Diproses! (No. NJM: ${formDataPoli.no_njm}, Antrian: ${noAntrianPoli}, Pasien: ${formDataPoli.nama})`
      });

      // Tambahkan ke list lokal
      const newPasien = {
        jam: new Date().toLocaleTimeString('id-ID', { hour: '2-digit', minute: '2-digit' }),
        jenkel: formDataPoli.jenkel,
        kd_dokter: '0308',
        nama_dok: formDataPoli.dokter_tujuan,
        nama: formDataPoli.nama,
        nm_klasifikasi: formDataPoli.nm_klasifikasi,
        no_medrec: formDataPoli.no_medrec,
        no_njm: formDataPoli.no_njm || `NJM-2026-${Math.floor(1000 + Math.random() * 9000)}`,
        no_sep: formDataPoli.no_sep || '-',
        prs_penjamin: formDataPoli.penjamin_pasien,
        tgl_kunj: formatYmdToDdmmyyyy(formDataPoli.tgl_daftar),
        userid: 'operator',
        usia: formDataPoli.usia,
        waktu: formDataPoli.waktu
      };

      setPasienList(prev => [newPasien, ...prev]);

      setTimeout(() => {
        setShowPoliModal(false);
      }, 1500);
    }, 1000);
  };

  return (
    <div style={styles.appContainer}>
      {/* ══ NAVBAR COMPACT HEADER ══ */}
      <nav style={styles.navbarCustom} className="d-flex align-items-center justify-content-between text-white shadow-sm">
        <div className="d-flex align-items-center gap-2">
          <span className="fw-bold fs-6 tracking-wide d-flex align-items-center gap-2">
            <i className="bi bi-person-lines-fill text-warning fs-5"></i>
            SIMRS — Pendaftaran Pasien Rawat Jalan (RJ)
          </span>
        </div>
        <div className="d-flex align-items-center gap-3">
          <span className="text-light" style={{ fontSize: '0.72rem', opacity: 0.9 }}>
            <i className="bi bi-calendar-event me-1"></i>{time.date} |
            <i className="bi bi-clock me-1 ms-1"></i>{time.clock}
          </span>
          <Button
            variant="warning"
            size="sm"
            className="fw-semibold text-dark shadow-sm"
            style={{ padding: '0.2rem 0.75rem', fontSize: '0.75rem', borderRadius: '6px' }}
            onClick={() => navigate('/home')}
          >
            <i className="bi bi-house-door-fill me-1"></i> Kembali ke Home
          </Button>
        </div>
      </nav>

      {/* ══ MAIN CONTENT ══ */}
      <div style={styles.mainContent}>

        {/* ── Stats Summary Bar Minimalis ── */}
        <Row className="g-2 mb-2">
          <Col md={3} sm={6}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f1f5f9', color: '#0f172a', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-people-fill fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0f172a', lineHeight: 1.1 }}>{pasienList.length}</div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Total Pasien Rawat Jalan</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f0fdfa', color: '#0d9488', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-shield-check fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0f172a', lineHeight: 1.1 }}>
                  {pasienList.filter(p => (p.nm_klasifikasi || '').toUpperCase() === 'BPJS').length}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Pasien BPJS Kesehatan</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f0f9ff', color: '#0284c7', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-file-earmark-check-fill fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1.1rem', color: '#0f172a', lineHeight: 1.1 }}>
                  {pasienList.filter(p => p.no_sep && p.no_sep !== '-').length}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Memiliki Nomor SEP</div>
              </div>
            </div>
          </Col>

          <Col md={3} sm={6}>
            <div style={{ background: '#ffffff', border: '1px solid #e2e8f0', borderRadius: '10px', padding: '0.55rem 0.8rem', display: 'flex', alignItems: 'center', gap: '0.65rem' }} className="shadow-sm">
              <div style={{ background: '#f8fafc', color: '#475569', borderRadius: '8px', width: '38px', height: '38px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <i className="bi bi-clock-history fs-5"></i>
              </div>
              <div>
                <div className="fw-bold" style={{ fontSize: '1rem', color: '#0f172a', lineHeight: 1.1 }}>
                  Pagi: {pasienList.filter(p => (p.waktu || '').toLowerCase() === 'pagi').length} | Sore: {pasienList.filter(p => (p.waktu || '').toLowerCase() === 'sore').length}
                </div>
                <div className="text-muted" style={{ fontSize: '0.68rem' }}>Sesi Pelayanan Waktu</div>
              </div>
            </div>
          </Col>
        </Row>

        {/* ── Main Card ── */}
        <Card style={styles.mainCard} className="shadow-sm border-0">
          {/* Card Header */}
          <div style={{ ...styles.cardHeader, ...styles.bgMenuHeader }}
            className="d-flex justify-content-between align-items-center flex-wrap gap-2">
            <span className="fw-bold">
              <i className="bi bi-person-workspace me-1 text-warning"></i>
              Daftar Pasien Rawat Jalan (Poliklinik)
            </span>
            <div className="d-flex gap-2 align-items-center flex-wrap">
              <Button
                variant="success"
                size="sm"
                className="fw-bold d-flex align-items-center gap-1.5 shadow-sm text-white"
                style={{ fontSize: '0.73rem', background: '#059669', borderColor: '#059669', borderRadius: '6px' }}
                onClick={handleOpenPendaftaranPoliModal}
              >
                <i className="bi bi-plus-circle-fill fs-6"></i>
                <span>Pendaftaran Poliklinik Baru</span>
              </Button>
              <Button
                variant="dark"
                size="sm"
                className="fw-bold d-flex align-items-center gap-1.5 shadow-sm text-white"
                style={{ fontSize: '0.73rem', background: '#1e293b', borderColor: '#1e293b', borderRadius: '6px' }}
                onClick={handleOpenEhrSyncModal}
              >
                <i className="bi bi-cpu-fill fs-6 text-warning"></i>
                <span>Sinkron Data EHR Sirrus</span>
              </Button>
              <Button
                variant="outline-light"
                size="sm"
                onClick={fetchPasienRjData}
                disabled={isLoading}
                style={{ fontSize: '0.73rem', borderRadius: '6px' }}
              >
                {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-arrow-clockwise"></i>} Refresh Data
              </Button>
            </div>
          </div>

          <Card.Body style={{ padding: '0.6rem' }}>
            {/* ── Filter Controls (Periode Tanggal Kunjungan & Pencarian) ── */}
            <Row className="g-2 mb-2 align-items-center">
              {/* Periode Tgl Awal (periode) */}
              <Col md={3} sm={6}>
                <Form.Group className="d-flex align-items-center gap-1">
                  <Form.Label className="mb-0 fw-semibold text-dark" style={{ fontSize: '0.73rem', whiteSpace: 'nowrap' }}>
                    Awal:
                  </Form.Label>
                  <Form.Control
                    type="date"
                    size="sm"
                    value={periode}
                    onChange={e => setPeriode(e.target.value)}
                    style={{ fontSize: '0.78rem' }}
                  />
                </Form.Group>
              </Col>

              {/* Periode Tgl Akhir (periode2) */}
              <Col md={3} sm={6}>
                <Form.Group className="d-flex align-items-center gap-1">
                  <Form.Label className="mb-0 fw-semibold text-dark" style={{ fontSize: '0.73rem', whiteSpace: 'nowrap' }}>
                    Akhir:
                  </Form.Label>
                  <Form.Control
                    type="date"
                    size="sm"
                    value={periode2}
                    onChange={e => setPeriode2(e.target.value)}
                    style={{ fontSize: '0.78rem' }}
                  />
                </Form.Group>
              </Col>

              {/* Tombol Filter Periode */}
              <Col md={2} sm={6}>
                <Button
                  variant="teal"
                  size="sm"
                  className="w-100 fw-bold d-flex align-items-center justify-content-center gap-1 text-white shadow-sm"
                  style={{ background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)', borderColor: '#0d9488', fontSize: '0.75rem' }}
                  onClick={fetchPasienRjData}
                  disabled={isLoading}
                >
                  {isLoading ? <Spinner size="sm" animation="border" /> : <i className="bi bi-funnel-fill"></i>}
                  <span>Filter Periode</span>
                </Button>
              </Col>

              {/* Filter Klasifikasi */}
              <Col md={2} sm={6}>
                <Form.Select
                  size="sm"
                  value={filterKlasifikasi}
                  onChange={e => { setFilterKlasifikasi(e.target.value); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value="">Semua Penjamin</option>
                  {uniqueKlasifikasi.map((k, i) => <option key={i} value={k}>{k}</option>)}
                </Form.Select>
              </Col>

              {/* Rows Per Page */}
              <Col md={2} sm={6}>
                <Form.Select
                  size="sm"
                  value={itemsPerPage}
                  onChange={e => { setItemsPerPage(Number(e.target.value)); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value={10}>10 Baris</option>
                  <option value={20}>20 Baris</option>
                  <option value={50}>50 Baris</option>
                  <option value={100}>100 Baris</option>
                </Form.Select>
              </Col>

              {/* Search Bar */}
              <Col md={9} sm={8}>
                <InputGroup size="sm">
                  <InputGroup.Text style={{ background: '#f8fafc', fontSize: '0.78rem' }}>
                    <i className="bi bi-search text-muted"></i>
                  </InputGroup.Text>
                  <Form.Control
                    placeholder="Cari Nama Pasien, No Medrec, Dokter, Penjamin, User ID..."
                    value={searchQuery}
                    onChange={e => { setSearchQuery(e.target.value); setCurrentPage(1); }}
                    style={{ fontSize: '0.78rem' }}
                  />
                  {searchQuery && (
                    <Button variant="outline-secondary" size="sm" onClick={() => setSearchQuery('')}>
                      ✕
                    </Button>
                  )}
                </InputGroup>
              </Col>

              {/* Filter Waktu */}
              <Col md={3} sm={4}>
                <Form.Select
                  size="sm"
                  value={filterWaktu}
                  onChange={e => { setFilterWaktu(e.target.value); setCurrentPage(1); }}
                  style={{ fontSize: '0.78rem' }}
                >
                  <option value="">Semua Waktu (Pagi/Sore)</option>
                  <option value="Pagi">Pagi</option>
                  <option value="Sore">Sore</option>
                </Form.Select>
              </Col>
            </Row>

            {fetchError && (
              <div className="alert alert-warning py-1 px-3 mb-2" style={{ fontSize: '0.75rem' }}>
                <i className="bi bi-exclamation-triangle-fill me-1"></i>{fetchError}
              </div>
            )}

            {/* ── Data Table ── */}
            <div className="table-responsive" style={{ maxHeight: 'calc(100vh - 280px)', overflowY: 'auto' }}>
              <Table responsive hover striped bordered size="sm" className="align-middle mb-0" style={{ fontSize: '0.75rem' }}>
                <thead style={{ background: '#0f172a', color: '#fff', position: 'sticky', top: 0, zIndex: 10 }}>
                  <tr>
                    <th className="text-center" style={{ width: '35px' }}>#</th>
                    <th className="text-center" style={{ width: '95px' }}>No. Medrec</th>
                    <th className="text-center" style={{ width: '125px' }}>No. NJM</th>
                    <th>Nama Pasien & Usia</th>
                    <th className="text-center">Tgl & Jam Kunjungan</th>
                    <th className="text-center">Penjamin / Klasifikasi</th>
                    <th>Dokter DPJP (nama_dok)</th>
                    <th className="text-center">Nomor SEP</th>
                    <th className="text-center">User ID</th>
                    <th className="text-center" style={{ width: '120px' }}>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {isLoading ? (
                    <tr>
                      <td colSpan="10" className="text-center py-4">
                        <Spinner animation="border" variant="teal" size="sm" className="me-2" />
                        <span>Memuat data pendaftaran pasien rawat jalan...</span>
                      </td>
                    </tr>
                  ) : currentItems.length > 0 ? (
                    currentItems.map((item, idx) => (
                      <tr key={idx}>
                        <td className="text-center text-muted">{indexOfFirst + idx + 1}</td>

                        {/* No Medrec */}
                        <td className="text-center align-middle">
                          <span className="fw-bold text-dark font-monospace" style={{ fontSize: '0.75rem' }}>
                            {item.no_medrec}
                          </span>
                        </td>

                        {/* No NJM (Nomor Nota Jasa Medis) */}
                        <td className="text-center align-middle">
                          <span className="fw-semibold text-dark font-monospace" style={{ fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                            {item.no_njm || '-'}
                          </span>
                        </td>

                        {/* Nama Pasien & Usia */}
                        <td>
                          <div className="fw-bold text-dark" style={{ fontSize: '0.76rem' }}>
                            {item.nama}
                          </div>
                          <div className="text-muted mt-1" style={{ fontSize: '0.68rem' }}>
                            <span className="fw-bold" style={{ color: (item.jenkel || '').toLowerCase().includes('wanita') || (item.jenkel || '').toLowerCase().includes('perempuan') ? '#ec4899' : '#3b82f6' }}>
                              {item.jenkel}
                            </span>
                            <span className="mx-1 text-secondary">|</span>
                            Usia: <strong className="text-dark">{item.usia} Th</strong>
                          </div>
                        </td>

                        {/* Tgl & Jam Kunjungan */}
                        <td className="text-center align-middle">
                          <div className="fw-semibold text-dark" style={{ fontSize: '0.73rem' }}>{item.tgl_kunj}</div>
                          <div className="text-muted mt-1" style={{ fontSize: '0.68rem' }}>
                            <i className="bi bi-clock me-1"></i>{item.jam} WIB
                            <span className="mx-1 text-secondary">|</span>
                            <span className="fw-bold" style={{ color: (item.waktu || '').toLowerCase() === 'pagi' ? '#eab308' : '#8b5cf6' }}>
                              {item.waktu}
                            </span>
                          </div>
                        </td>

                        {/* Penjamin & Klasifikasi */}
                        <td className="text-center align-middle">
                          <div className="fw-bold text-dark" style={{ fontSize: '0.73rem' }}>{item.prs_penjamin}</div>
                          <div className="mt-1">
                            <span className="fw-bold" style={{ fontSize: '0.68rem', color: (item.nm_klasifikasi || '').toUpperCase() === 'BPJS' ? '#10b981' : '#f59e0b' }}>
                              {item.nm_klasifikasi}
                            </span>
                          </div>
                        </td>

                        {/* Dokter DPJP (nama_dok & kd_dokter) */}
                        <td className="align-middle" style={{ fontSize: '0.73rem' }}>
                          <div className="fw-bold text-dark">{item.nama_dok || '—'}</div>
                          <div className="text-muted mt-1" style={{ fontSize: '0.67rem' }}>
                            <span className="fw-semibold font-monospace" style={{ color: '#0d9488' }}>
                              <i className="bi bi-person-badge me-1"></i>Kode: {item.kd_dokter}
                            </span>
                          </div>
                        </td>

                        {/* Nomor SEP */}
                        <td className="text-center align-middle">
                          {item.no_sep && item.no_sep !== '-' ? (
                            <span className="fw-bold text-teal font-monospace" style={{ color: '#0d9488', fontSize: '0.75rem', letterSpacing: '0.5px' }}>
                              {item.no_sep}
                            </span>
                          ) : (
                            <span className="text-muted fst-italic" style={{ fontSize: '0.7rem' }}>
                              Belum Ada SEP
                            </span>
                          )}
                        </td>

                        {/* User ID */}
                        <td className="text-center text-muted" style={{ fontSize: '0.72rem' }}>
                          <i className="bi bi-person me-1"></i>{item.userid}
                        </td>

                        {/* Tombol Aksi */}
                        <td className="text-center">
                          <div className="d-flex justify-content-center align-items-center gap-1">
                            <OverlayTrigger placement="top" overlay={<Tooltip>Detail Pasien RJ</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px', borderColor: '#cbd5e1', color: '#0f172a' }}
                                onClick={() => handleOpenDetailModal(item)}
                              >
                                <i className="bi bi-eye-fill"></i>
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement="top" overlay={<Tooltip>Cetak Nota Jasa Medis (NJM)</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-warning"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px', borderColor: '#f59e0b', color: '#d97706', background: '#fffbeb' }}
                                onClick={() => handleCetakNjmTableRow(item)}
                              >
                                <i className="bi bi-printer-fill"></i>
                              </Button>
                            </OverlayTrigger>

                            <OverlayTrigger placement="top" overlay={<Tooltip>Edit Nomor SEP</Tooltip>}>
                              <Button
                                size="sm"
                                variant="outline-secondary"
                                style={{ padding: '0.15rem 0.4rem', fontSize: '0.7rem', borderRadius: '5px', borderColor: '#cbd5e1', color: '#0d9488' }}
                                onClick={() => handleOpenEditSep(item)}
                              >
                                <i className="bi bi-pencil-square"></i>
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="10" className="text-center py-4 text-muted">
                        Tidak ada data pendaftaran pasien rawat jalan yang ditemukan.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </div>

            {/* ── Pagination ── */}
            {totalPages > 1 && (
              <div className="d-flex justify-content-center mt-3">
                <Pagination size="sm" className="mb-0">
                  <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
                  <Pagination.Prev onClick={() => setCurrentPage(p => Math.max(p - 1, 1))} disabled={currentPage === 1} />
                  {[...Array(Math.min(totalPages, 10))].map((_, i) => (
                    <Pagination.Item key={i + 1} active={i + 1 === currentPage} onClick={() => setCurrentPage(i + 1)}>
                      {i + 1}
                    </Pagination.Item>
                  ))}
                  {totalPages > 10 && <Pagination.Ellipsis disabled />}
                  <Pagination.Next onClick={() => setCurrentPage(p => Math.min(p + 1, totalPages))} disabled={currentPage === totalPages} />
                  <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
                </Pagination>
              </div>
            )}

            {/* ── Footer Info ── */}
            <div className="d-flex justify-content-between mt-3 pt-2 border-top text-muted" style={{ fontSize: '0.72rem' }}>
              <span>
                Menampilkan{' '}
                <strong>{filteredData.length > 0 ? indexOfFirst + 1 : 0}–{Math.min(indexOfLast, filteredData.length)}</strong>{' '}
                dari <strong>{filteredData.length}</strong> pasien RJ (Total: {pasienList.length})
              </span>
              <span>IP Server: <strong>{getApiUrl()}</strong></span>
            </div>
          </Card.Body>
        </Card>
      </div>

      {/* ══ MODAL DETAIL PASIEN RJ ══ */}
      <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered size="md">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-person-lines-fill text-warning fs-5"></i>
            <span>Detail Pendaftaran Pasien Rawat Jalan</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          {selectedPasien && (
            <div>
              <Card className="border-0 shadow-sm mb-3">
                <Card.Body className="p-3" style={{ fontSize: '0.78rem' }}>
                  <Row className="g-2">
                    <Col md={12} className="border-bottom pb-2 mb-2">
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Nama Pasien</div>
                      <div className="fw-bold text-dark fs-6">{selectedPasien.nama}</div>
                      <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                        Usia: <strong>{selectedPasien.usia} Tahun</strong> | Jenis Kelamin: <strong>{selectedPasien.jenkel}</strong>
                      </div>
                    </Col>
                    <Col md={6}>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>No. Medrec (MR)</div>
                      <div className="fw-bold text-teal font-monospace">{selectedPasien.no_medrec}</div>
                    </Col>
                    <Col md={6}>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Nomor SEP</div>
                      <div className="fw-bold text-primary font-monospace">{selectedPasien.no_sep || '-'}</div>
                    </Col>
                    <Col md={6}>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Tanggal & Jam Kunjungan</div>
                      <div className="fw-semibold">{selectedPasien.tgl_kunj} ({selectedPasien.jam} WIB) - {selectedPasien.waktu}</div>
                    </Col>
                    <Col md={6}>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Dokter DPJP (nama_dok)</div>
                      <div className="fw-bold text-dark">{selectedPasien.nama_dok || '—'}</div>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Kode Dokter: {selectedPasien.kd_dokter}</div>
                    </Col>
                    <Col md={6}>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Perusahaan Penjamin</div>
                      <div className="fw-semibold text-primary">{selectedPasien.prs_penjamin}</div>
                    </Col>
                    <Col md={6}>
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Klasifikasi</div>
                      <div>
                        <Badge bg="success" style={{ fontSize: '0.7rem' }}>{selectedPasien.nm_klasifikasi}</Badge>
                      </div>
                    </Col>
                    <Col md={12} className="border-top pt-2 mt-2">
                      <div className="text-muted" style={{ fontSize: '0.68rem' }}>Petugas Pendaftar (User ID)</div>
                      <div className="fw-semibold text-dark"><i className="bi bi-person-badge me-1"></i>{selectedPasien.userid}</div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <div className="d-flex justify-content-end gap-2 border-top pt-2">
                <Button variant="secondary" size="sm" onClick={() => setShowDetailModal(false)}>
                  Tutup
                </Button>
                <Button variant="primary" size="sm" className="fw-bold" onClick={() => { setShowDetailModal(false); handleOpenEditSep(selectedPasien); }}>
                  <i className="bi bi-pencil-square me-1"></i> Edit Nomor SEP
                </Button>
              </div>
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL EDIT NOMOR SEP ══ */}
      <Modal show={showEditSepModal} onHide={() => setShowEditSepModal(false)} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0284c7 0%, #0369a1 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.9rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-pencil-square fs-5 text-warning"></i>
            <span>Edit Nomor SEP Pasien Rawat Jalan</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          <Form onSubmit={handleSaveSep}>
            {selectedPasien && (
              <div className="alert alert-primary py-2 px-3 mb-3" style={{ fontSize: '0.76rem' }}>
                <div><strong>Pasien:</strong> {selectedPasien.nama} ({selectedPasien.no_medrec})</div>
                <div><strong>Tgl Kunjungan:</strong> {selectedPasien.tgl_kunj}</div>
              </div>
            )}

            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.78rem' }}>
                Masukkan Nomor SEP Terbaru
              </Form.Label>
              <Form.Control
                type="text"
                placeholder="Contoh: 0117R0750826V000550"
                value={inputNoSep}
                onChange={e => setInputNoSep(e.target.value)}
                required
                style={{ fontSize: '0.85rem', fontWeight: '600' }}
                className="font-monospace"
              />
            </Form.Group>

            {sepFeedback && (
              <div className={`alert alert-${sepFeedback.type} py-1 px-2 mb-3`} style={{ fontSize: '0.73rem' }}>
                <i className="bi bi-info-circle-fill me-1"></i>
                {sepFeedback.text}
              </div>
            )}

            <div className="d-flex justify-content-end gap-2 border-top pt-2">
              <Button type="button" variant="secondary" size="sm" onClick={() => setShowEditSepModal(false)} disabled={isSavingSep}>
                Batal
              </Button>
              <Button type="submit" size="sm" variant="primary" className="fw-bold" disabled={isSavingSep}>
                {isSavingSep ? <Spinner size="sm" animation="border" className="me-1" /> : <i className="bi bi-save me-1"></i>}
                Simpan SEP
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ══ MODAL KONFIRMASI & PROGRESS SINKRON DATA EHR SIRRUS (syncsirrusrj) ══ */}
      <Modal show={showEhrSyncModal} onHide={handleCloseEhrSyncModal} centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0d9488 0%, #0f766e 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.92rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-cpu-fill fs-5 text-warning"></i>
            <span>Sinkronisasi Data ke Aplikasi EHR Sirrus</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-light">
          {!isSyncingEhr && !ehrSyncFeedback ? (
            /* Langkah 1: Konfirmasi */
            <div>
              <div className="alert alert-teal border-0 shadow-sm p-3 mb-3" style={{ background: '#f0fdfa', borderLeft: '4px solid #0d9488', borderRadius: '10px' }}>
                <div className="fw-bold text-dark mb-1" style={{ fontSize: '0.85rem' }}>
                  <i className="bi bi-question-circle-fill me-1 text-teal" style={{ color: '#0d9488' }}></i> Konfirmasi Sinkron Data EHR
                </div>
                <div className="text-dark" style={{ fontSize: '0.78rem' }}>
                  Apakah Anda yakin ingin melakukan <strong>Sinkronisasi Data Pasien Rawat Jalan ke Aplikasi EHR Sirrus</strong> untuk periode <strong>{formatYmdToDdmmyyyy(periode)} s/d {formatYmdToDdmmyyyy(periode2)}</strong>?
                </div>
              </div>

              <p className="text-muted text-center mb-3" style={{ fontSize: '0.73rem' }}>
                Sistem akan memanggil backend <code>/syncsirrusrj</code> dan mengirimkan data pendaftaran pasien ke ekosistem EHR.
              </p>

              <div className="d-flex justify-content-center gap-2 border-top pt-3">
                <Button
                  variant="secondary"
                  size="sm"
                  style={{ borderRadius: '6px', padding: '0.35rem 1.2rem', fontSize: '0.78rem' }}
                  onClick={handleCloseEhrSyncModal}
                >
                  <i className="bi bi-x-circle me-1"></i> Tidak / Kembali
                </Button>
                <Button
                  variant="teal"
                  size="sm"
                  className="fw-bold text-white shadow-sm d-flex align-items-center gap-1"
                  style={{ borderRadius: '6px', padding: '0.35rem 1.2rem', fontSize: '0.78rem', background: '#0d9488', borderColor: '#0d9488' }}
                  onClick={handleProcessSyncEhr}
                >
                  <i className="bi bi-check-circle-fill me-1"></i>
                  <span>Ya, Lakukan Sinkronisasi</span>
                </Button>
              </div>
            </div>
          ) : (
            /* Langkah 2: Progress & Feedback */
            <div>
              <div className="text-center py-2 mb-2">
                <i className={`bi ${ehrSyncProgress === 100 ? 'bi-check-circle-fill text-success' : 'bi-cpu-fill text-teal'} display-5`} style={{ color: ehrSyncProgress < 100 ? '#0d9488' : undefined }}></i>
                <div className="fw-bold text-dark mt-2" style={{ fontSize: '0.88rem' }}>
                  {ehrSyncStatusText || 'Sedang memproses sinkronisasi EHR Sirrus...'}
                </div>
              </div>

              <div className="mb-3 px-2">
                <div className="d-flex justify-content-between small fw-semibold text-dark mb-1" style={{ fontSize: '0.75rem' }}>
                  <span>Progres Sinkronisasi EHR</span>
                  <span className="fw-bold" style={{ color: '#0d9488' }}>{ehrSyncProgress}%</span>
                </div>
                <ProgressBar
                  animated={ehrSyncProgress < 100}
                  striped
                  variant={ehrSyncProgress === 100 ? 'success' : 'teal'}
                  now={ehrSyncProgress}
                  style={{ height: '16px', borderRadius: '8px', backgroundColor: '#e2e8f0' }}
                />
              </div>

              {ehrSyncFeedback && (
                <div className={`alert alert-${ehrSyncFeedback.type} py-2 px-3 mb-3`} style={{ fontSize: '0.76rem' }}>
                  <i className="bi bi-info-circle-fill me-1"></i>
                  {ehrSyncFeedback.text}
                </div>
              )}

              {ehrSyncProgress === 100 && (
                <div className="d-flex justify-content-end border-top pt-2">
                  <Button variant="teal" size="sm" className="fw-bold text-white px-3" style={{ background: '#0d9488', borderColor: '#0d9488' }} onClick={handleCloseEhrSyncModal}>
                    Selesai
                  </Button>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
      </Modal>

      {/* ══ MODAL UI/UX FORM PENDAFTARAN PASIEN RAWAT JALAN POLIKLINIK (FIT 1 LAYAR COMPACT) ══ */}
      <Modal show={showPoliModal} onHide={handleClosePendaftaranPoliModal} size="xl" centered backdrop="static" dialogClassName="modal-95w">
        <Modal.Header closeButton className="py-2 px-3" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', color: '#fff', borderBottom: '2px solid #0d9488' }}>
          <Modal.Title style={{ fontSize: '0.88rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-hospital-fill text-warning fs-6"></i>
            <span>PENDAFTARAN PASIEN RAWAT JALAN POLIKLINIK</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-2" style={{ background: '#f8fafc', maxHeight: 'calc(100vh - 80px)', overflowY: 'auto' }}>
          <Form onSubmit={handleProsesPoliSubmit}>
            <Row className="g-2">
              {/* ── SEKSI KIRI / UTAMA (9 COLS): FORM ISIAN Ultra-Compact ── */}
              <Col md={9}>
                {/* 1. Header Bar: Dokter Tujuan, Tanggal Daftar & Sesi Waktu */}
                <Card className="border-0 shadow-sm mb-1.5" style={{ borderRadius: '8px', background: '#ffffff', borderLeft: '4px solid #0d9488', position: 'relative', zIndex: 100, overflow: 'visible' }}>
                  <Card.Body className="py-1.5 px-2.5">
                    <Row className="g-2 align-items-center">
                      <Col md={6}>
                        <Form.Group className="d-flex align-items-center gap-1.5 position-relative">
                          <Form.Label className="text-uppercase fw-bold mb-0 text-dark" style={{ fontSize: '0.64rem', whiteSpace: 'nowrap' }}>
                            <i className="bi bi-person-badge me-1 text-teal" style={{ color: '#0d9488' }}></i> DOKTER TUJUAN:
                          </Form.Label>
                          <div className="position-relative w-100">
                            <Form.Control
                              type="text"
                              size="sm"
                              placeholder="Cari Nama Dokter / Spesialis..."
                              value={showDokterDropdown ? searchDokterQuery : formDataPoli.dokter_tujuan}
                              onFocus={() => {
                                setSearchDokterQuery('');
                                setShowDokterDropdown(true);
                              }}
                              onChange={e => {
                                setSearchDokterQuery(e.target.value);
                                setFormDataPoli(prev => ({ ...prev, dokter_tujuan: e.target.value }));
                                setShowDokterDropdown(true);
                              }}
                              style={{ fontSize: '0.74rem', fontWeight: '700', color: '#0f172a', borderRadius: '6px', height: '27px', padding: '0.15rem 0.4rem' }}
                            />
                            {showDokterDropdown && (
                              <div
                                className="position-absolute w-100 bg-white border rounded shadow-lg"
                                style={{ top: '100%', left: 0, zIndex: 1055, maxHeight: '200px', overflowY: 'auto', marginTop: '2px', borderColor: '#cbd5e1' }}
                              >
                                <div className="p-1 px-2 bg-light border-bottom text-muted fw-bold d-flex justify-content-between align-items-center" style={{ fontSize: '0.62rem' }}>
                                  <span><i className="bi bi-search me-1"></i> DAFTAR DOKTER & SPESIALIS</span>
                                  <span className="text-danger cursor-pointer" style={{ cursor: 'pointer' }} onClick={() => setShowDokterDropdown(false)}>Tutup ✕</span>
                                </div>
                                {dokterOptions.filter(dok => {
                                  const name = (dok.nama_dok || dok.nama || dok.nama_dokter || dok.nm_dokter || '').toLowerCase();
                                  const spec = (dok.specialis || dok.spesialis || '').toLowerCase();
                                  const q = searchDokterQuery.toLowerCase();
                                  return name.includes(q) || spec.includes(q);
                                }).length > 0 ? (
                                  dokterOptions
                                    .filter(dok => {
                                      const name = (dok.nama_dok || dok.nama || dok.nama_dokter || dok.nm_dokter || '').toLowerCase();
                                      const spec = (dok.specialis || dok.spesialis || '').toLowerCase();
                                      const q = searchDokterQuery.toLowerCase();
                                      return name.includes(q) || spec.includes(q);
                                    })
                                    .map((dok, idx) => {
                                      const docNama = dok.nama_dok || dok.nama || dok.nama_dokter || dok.nm_dokter || 'Dokter';
                                      const docSpec = dok.specialis || dok.spesialis || '';
                                      const isSelected = formDataPoli.dokter_tujuan === docNama;
                                      return (
                                        <div
                                          key={dok.nodok || idx}
                                          className="p-1.5 px-2 border-bottom cursor-pointer d-flex justify-content-between align-items-center"
                                          style={{ fontSize: '0.73rem', cursor: 'pointer', background: isSelected ? '#f0fdfa' : '#ffffff' }}
                                          onClick={() => {
                                            setFormDataPoli(prev => ({ ...prev, dokter_tujuan: docNama }));
                                            setShowDokterDropdown(false);
                                          }}
                                        >
                                          <div>
                                            <div className="fw-bold text-dark">{docNama}</div>
                                            {docSpec && (
                                              <div className="text-teal" style={{ fontSize: '0.65rem', color: '#0d9488', fontWeight: '600' }}>
                                                <i className="bi bi-award me-1"></i>{docSpec}
                                              </div>
                                            )}
                                          </div>
                                          {isSelected && (
                                            <span className="badge bg-teal" style={{ background: '#0d9488', fontSize: '0.6rem' }}>Terpilih</span>
                                          )}
                                        </div>
                                      );
                                    })
                                ) : (
                                  <div className="p-2.5 text-muted text-center" style={{ fontSize: '0.72rem' }}>
                                    <i className="bi bi-exclamation-circle me-1 text-warning"></i> Dokter atau spesialisasi tidak ditemukan
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group className="d-flex align-items-center gap-1.5">
                          <Form.Label className="text-uppercase fw-bold mb-0 text-dark" style={{ fontSize: '0.64rem', whiteSpace: 'nowrap' }}>
                            <i className="bi bi-calendar3 me-1 text-teal" style={{ color: '#0d9488' }}></i> TGL DAFTAR:
                          </Form.Label>
                          <Form.Control
                            type="date"
                            size="sm"
                            value={formDataPoli.tgl_daftar}
                            onChange={e => setFormDataPoli({ ...formDataPoli, tgl_daftar: e.target.value })}
                            style={{ fontSize: '0.74rem', fontWeight: '600', color: '#0f172a', borderRadius: '6px', height: '27px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group className="d-flex align-items-center gap-1.5">
                          <Form.Label className="text-uppercase fw-bold mb-0 text-dark" style={{ fontSize: '0.64rem', whiteSpace: 'nowrap' }}>
                            <i className="bi bi-clock-history me-1 text-teal" style={{ color: '#0d9488' }}></i> SESI:
                          </Form.Label>
                          <Form.Select
                            size="sm"
                            value={formDataPoli.waktu}
                            onChange={e => setFormDataPoli({ ...formDataPoli, waktu: e.target.value })}
                            style={{ fontSize: '0.74rem', fontWeight: '700', color: '#0d9488', borderRadius: '6px', background: '#f0fdfa', height: '27px', padding: '0.15rem 0.4rem' }}
                          >
                            <option value="Pagi">Pagi</option>
                            <option value="Sore">Sore</option>
                            <option value="Malam">Malam</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* 2. Blok Seksi A: Identitas Demografi & KTP Pasien */}
                <Card className="border shadow-sm mb-1.5" style={{ borderRadius: '8px', background: '#ffffff', borderColor: '#e2e8f0', position: 'relative', zIndex: 1 }}>
                  <div className="px-2.5 py-1 border-bottom d-flex align-items-center gap-1.5" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
                    <i className="bi bi-person-vcard text-teal fs-6" style={{ color: '#0d9488' }}></i>
                    <span className="fw-bold text-dark" style={{ fontSize: '0.72rem' }}>1. Identitas Demografi & KTP Pasien</span>
                  </div>
                  <Card.Body className="p-2">
                    <Row className="g-1.5">
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>No. Medrec (KIRS)</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="No. Medrec"
                            value={formDataPoli.no_medrec}
                            onChange={e => setFormDataPoli({ ...formDataPoli, no_medrec: e.target.value })}
                            style={{ fontSize: '0.74rem', fontFamily: 'monospace', fontWeight: 'bold', color: '#0d9488', background: '#f0fdfa', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Nama Panggilan</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Panggilan"
                            value={formDataPoli.nama_panggil}
                            onChange={e => setFormDataPoli({ ...formDataPoli, nama_panggil: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Nama Lengkap Pasien</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Nama Lengkap"
                            value={formDataPoli.nama}
                            onChange={e => setFormDataPoli({ ...formDataPoli, nama: e.target.value })}
                            style={{ fontSize: '0.74rem', fontWeight: 'bold', color: '#0f172a', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={2}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Kelamin</Form.Label>
                          <Form.Select
                            size="sm" value={formDataPoli.jenkel}
                            onChange={e => setFormDataPoli({ ...formDataPoli, jenkel: e.target.value })}
                            style={{ fontSize: '0.72rem', height: '26px', padding: '0.15rem 0.3rem' }}
                          >
                            <option value="Laki - Laki">Laki - Laki</option>
                            <option value="Wanita">Wanita / Perempuan</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Tempat Lahir</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Tempat Lahir"
                            value={formDataPoli.tmp_lahir}
                            onChange={e => setFormDataPoli({ ...formDataPoli, tmp_lahir: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Tgl Lahir</Form.Label>
                          <Form.Control
                            type="date" size="sm"
                            value={formDataPoli.tgl_lahir}
                            onChange={e => setFormDataPoli({ ...formDataPoli, tgl_lahir: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Usia</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Usia"
                            value={formDataPoli.usia}
                            onChange={e => setFormDataPoli({ ...formDataPoli, usia: e.target.value })}
                            style={{ fontSize: '0.74rem', fontWeight: 'bold', background: '#fef9c3', color: '#854d0e', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={2}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Pekerjaan</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Pekerjaan"
                            value={formDataPoli.pekerjaan}
                            onChange={e => setFormDataPoli({ ...formDataPoli, pekerjaan: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Institusi / Tempat Kerja</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Institusi Tempat Kerja"
                            value={formDataPoli.institusi}
                            onChange={e => setFormDataPoli({ ...formDataPoli, institusi: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Jenis Identitas</Form.Label>
                          <Form.Select
                            size="sm" value={formDataPoli.jenis_identitas}
                            onChange={e => setFormDataPoli({ ...formDataPoli, jenis_identitas: e.target.value })}
                            style={{ fontSize: '0.72rem', height: '26px', padding: '0.15rem 0.3rem' }}
                          >
                            <option value="KTP">KTP</option>
                            <option value="SIM">SIM</option>
                            <option value="PASSPORT">PASSPORT</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>No. KTP / NIK Identitas (16 Digit)</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="16 Digit NIK KTP Pasien"
                            value={formDataPoli.no_ktp}
                            onChange={e => setFormDataPoli({ ...formDataPoli, no_ktp: e.target.value })}
                            style={{ fontSize: '0.74rem', fontFamily: 'monospace', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                {/* 3. Blok Seksi B: Penjaminan, Klasifikasi, Rujukan & SEP BPJS */}
                <Card className="border shadow-sm mb-1.5" style={{ borderRadius: '8px', background: '#ffffff', borderColor: '#e2e8f0' }}>
                  <div className="px-2.5 py-1 border-bottom d-flex align-items-center gap-1.5" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
                    <i className="bi bi-shield-check text-teal fs-6" style={{ color: '#0d9488' }}></i>
                    <span className="fw-bold text-dark" style={{ fontSize: '0.72rem' }}>2. Penjaminan, Klasifikasi, Rujukan & SEP BPJS</span>
                  </div>
                  <Card.Body className="p-2">
                    <Row className="g-1.5">
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Penjamin Pasien</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Penjamin Pasien"
                            value={formDataPoli.penjamin_pasien}
                            onChange={e => setFormDataPoli({ ...formDataPoli, penjamin_pasien: e.target.value })}
                            style={{ fontSize: '0.74rem', fontWeight: 'bold', color: '#0284c7', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Nomor NJM</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Nomor NJM"
                            value={formDataPoli.no_njm}
                            onChange={e => setFormDataPoli({ ...formDataPoli, no_njm: e.target.value })}
                            style={{ fontSize: '0.74rem', fontFamily: 'monospace', fontWeight: 'bold', background: '#fef3c7', color: '#92400e', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Klasifikasi Pasien</Form.Label>
                          <Form.Select
                            size="sm" value={formDataPoli.nm_klasifikasi}
                            onChange={e => setFormDataPoli({ ...formDataPoli, nm_klasifikasi: e.target.value })}
                            style={{ fontSize: '0.72rem', fontWeight: 'bold', color: '#16a34a', height: '26px', padding: '0.15rem 0.3rem' }}
                          >
                            <option value="BPJS">BPJS KESEHATAN</option>
                            <option value="UMUM">UMUM / MANDIRI</option>
                            <option value="ASURANSI">ASURANSI SWASTA</option>
                            <option value="COB">COB (COORDINATION OF BENEFIT)</option>
                          </Form.Select>
                        </Form.Group>
                      </Col>
                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>NIP / No Pegawai</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="NIP"
                            value={formDataPoli.nip}
                            onChange={e => setFormDataPoli({ ...formDataPoli, nip: e.target.value })}
                            style={{ fontSize: '0.74rem', fontFamily: 'monospace', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Nama Lengkap Penjamin</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Nama Lengkap Penjamin"
                            value={formDataPoli.nama_penjamin}
                            onChange={e => setFormDataPoli({ ...formDataPoli, nama_penjamin: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Nama Perusahaan</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Nama Perusahaan"
                            value={formDataPoli.nm_perusahaan}
                            onChange={e => setFormDataPoli({ ...formDataPoli, nm_perusahaan: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Jenis Kartu Jaminan</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Jenis Kartu Jaminan"
                            value={formDataPoli.jenis_kartu}
                            onChange={e => setFormDataPoli({ ...formDataPoli, jenis_kartu: e.target.value })}
                            style={{ fontSize: '0.74rem', height: '26px', padding: '0.15rem 0.4rem' }}
                          />
                        </Form.Group>
                      </Col>

                      <Col md={3}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Berlaku s/d Kadaluarsa</Form.Label>
                          <div className="d-flex gap-1">
                            <Form.Control
                              type="date" size="sm"
                              value={formDataPoli.tgl_berlaku}
                              onChange={e => setFormDataPoli({ ...formDataPoli, tgl_berlaku: e.target.value })}
                              style={{ fontSize: '0.7rem', height: '26px', padding: '0.1rem 0.2rem' }}
                            />
                            <Form.Control
                              type="date" size="sm"
                              value={formDataPoli.tgl_kadaluarsa}
                              onChange={e => setFormDataPoli({ ...formDataPoli, tgl_kadaluarsa: e.target.value })}
                              style={{ fontSize: '0.7rem', height: '26px', padding: '0.1rem 0.2rem' }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={4}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>No & Nama di Kartu Jaminan</Form.Label>
                          <div className="d-flex gap-1">
                            <Form.Control
                              type="text" size="sm" placeholder="No. Kartu"
                              value={formDataPoli.no_kartu}
                              onChange={e => setFormDataPoli({ ...formDataPoli, no_kartu: e.target.value })}
                              style={{ fontSize: '0.72rem', fontFamily: 'monospace', height: '26px', padding: '0.15rem 0.3rem' }}
                            />
                            <Form.Control
                              type="text" size="sm" placeholder="Nama Kartu"
                              value={formDataPoli.nama_di_kartu}
                              onChange={e => setFormDataPoli({ ...formDataPoli, nama_di_kartu: e.target.value })}
                              style={{ fontSize: '0.72rem', height: '26px', padding: '0.15rem 0.3rem' }}
                            />
                          </div>
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-semibold mb-0" style={{ fontSize: '0.62rem', color: '#64748b' }}>Jenis Rujukan & Nama Perujuk</Form.Label>
                          <div className="d-flex gap-1">
                            <Form.Control
                              type="text" size="sm" placeholder="Jenis"
                              value={formDataPoli.jenis_rujukan}
                              onChange={e => setFormDataPoli({ ...formDataPoli, jenis_rujukan: e.target.value })}
                              style={{ fontSize: '0.72rem', height: '26px', padding: '0.15rem 0.3rem', width: '35%' }}
                            />
                            <Form.Control
                              type="text" size="sm" placeholder="Faskes Perujuk"
                              value={formDataPoli.nama_perujuk}
                              onChange={e => setFormDataPoli({ ...formDataPoli, nama_perujuk: e.target.value })}
                              style={{ fontSize: '0.72rem', height: '26px', padding: '0.15rem 0.3rem', width: '65%' }}
                            />
                          </div>
                        </Form.Group>
                      </Col>

                      <Col md={7}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-bold mb-0" style={{ fontSize: '0.63rem', color: '#0284c7' }}>Nomor SEP BPJS (19 Digit)</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="Nomor SEP BPJS"
                            value={formDataPoli.no_sep}
                            onChange={e => setFormDataPoli({ ...formDataPoli, no_sep: e.target.value })}
                            style={{ fontSize: '0.76rem', fontFamily: 'monospace', fontWeight: 'bold', color: '#0284c7', background: '#f0f9ff', height: '26px', padding: '0.15rem 0.4rem', borderColor: '#bae6fd' }}
                          />
                        </Form.Group>
                      </Col>
                      <Col md={5}>
                        <Form.Group>
                          <Form.Label className="text-uppercase fw-bold mb-0" style={{ fontSize: '0.63rem', color: '#e11d48' }}>Perusahaan Penjamin COB</Form.Label>
                          <Form.Control
                            type="text" size="sm" placeholder="COB"
                            value={formDataPoli.perusahaan_cob}
                            onChange={e => setFormDataPoli({ ...formDataPoli, perusahaan_cob: e.target.value })}
                            style={{ fontSize: '0.76rem', fontWeight: 'bold', color: '#be123c', background: '#fff1f2', height: '26px', padding: '0.15rem 0.4rem', borderColor: '#fca5a5' }}
                          />
                        </Form.Group>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>

              {/* ── SEKSI KANAN (3 COLS): PANEL KONTROL Ultra-Compact ── */}
              <Col md={3}>
                <Card className="border-0 shadow-sm h-100 bg-white overflow-hidden" style={{ borderRadius: '10px', borderColor: '#e2e8f0' }}>
                  <Card.Body className="p-2 d-flex flex-column justify-content-between">
                    <div>
                      {/* Brand Header Right */}
                      <div className="text-center pb-1.5 border-bottom mb-2" style={{ borderColor: '#f1f5f9' }}>
                        <div className="d-inline-flex align-items-center justify-content-center rounded-circle p-1.5 mb-1 shadow-sm text-white" style={{ background: 'linear-gradient(135deg, #0f172a 0%, #0d9488 100%)', width: '40px', height: '40px' }}>
                          <i className="bi bi-hospital text-warning fs-5"></i>
                        </div>
                        <div className="fw-bold text-dark" style={{ fontSize: '0.78rem', letterSpacing: '0.3px' }}>POLIKLINIK UTAMA</div>
                        <div className="text-muted" style={{ fontSize: '0.62rem' }}>SIMRS REGISTER SYSTEM</div>
                      </div>

                      {/* Live System Info Card */}
                      <div className="p-2 rounded-3 text-center mb-2 border shadow-sm" style={{ background: '#f8fafc', borderColor: '#e2e8f0' }}>
                        <div className="text-muted text-uppercase mb-0" style={{ fontSize: '0.6rem' }}>TANGGAL SYSTEM</div>
                        <div className="fw-bold text-dark mb-1" style={{ fontSize: '0.78rem' }}>{time.date || '08/08/2026'}</div>

                        <div className="text-muted text-uppercase mb-0" style={{ fontSize: '0.6rem' }}>WAKTU OPERASIONAL</div>
                        <div className="fw-bold text-teal" style={{ fontSize: '0.78rem', color: '#0d9488' }}>{time.clock || '18:33:00 WIB'}</div>
                      </div>

                      {/* Box Nomor Antrian Display */}
                      <div className="p-2 rounded-3 text-center mb-2 border shadow-sm" style={{ background: 'linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)', borderColor: '#a7f3d0' }}>
                        <div className="text-emerald-700 text-uppercase fw-bold mb-0" style={{ fontSize: '0.64rem', color: '#047857' }}>
                          NOMOR ANTRIAN POLI
                        </div>
                        <div className="fw-bold font-monospace display-6 my-0" style={{ color: '#059669', fontSize: '1.8rem' }}>
                          {noAntrianPoli}
                        </div>
                      </div>

                      {poliFeedback && (
                        <div className={`alert alert-${poliFeedback.type} py-1 px-2 mb-2 text-center shadow-sm`} style={{ fontSize: '0.7rem', borderRadius: '6px' }}>
                          {poliFeedback.text}
                        </div>
                      )}
                    </div>

                    {/* Tombol Aksi Ultra-Compact (PROSES, DAFTAR EHR, ULANG NJM, KELUAR) */}
                    <div className="d-grid gap-1.5 pt-2 border-top" style={{ borderColor: '#f1f5f9' }}>
                      {/* Tombol PROSES */}
                      <Button
                        type="submit"
                        variant="success"
                        size="sm"
                        className="fw-bold py-1.5 shadow-sm d-flex align-items-center justify-content-center gap-1.5 text-white border-0"
                        style={{ fontSize: '0.8rem', background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', borderRadius: '6px' }}
                        disabled={isSubmittingPoli}
                      >
                        {isSubmittingPoli ? <Spinner size="sm" animation="border" /> : <i className="bi bi-check-circle-fill"></i>}
                        <span>PROSES PENDAFTARAN</span>
                      </Button>

                      {/* Tombol DAFTAR EHR */}
                      <Button
                        type="button"
                        variant="outline-primary"
                        size="sm"
                        className="fw-bold py-1 d-flex align-items-center justify-content-center gap-1"
                        style={{ fontSize: '0.74rem', borderRadius: '6px' }}
                        onClick={() => {
                          handleClosePendaftaranPoliModal();
                          handleOpenEhrSyncModal();
                        }}
                      >
                        <i className="bi bi-cpu-fill"></i>
                        <span>DAFTAR EHR SIRRUS</span>
                      </Button>

                      {/* Tombol ULANG NJM */}
                      <Button
                        type="button"
                        variant="outline-warning"
                        size="sm"
                        className="fw-bold py-1 text-dark d-flex align-items-center justify-content-center gap-1"
                        style={{ fontSize: '0.74rem', borderRadius: '6px' }}
                        onClick={handleOpenUlangNjmModal}
                      >
                        <i className="bi bi-arrow-counterclockwise"></i>
                        <span>ULANG NJM</span>
                      </Button>

                      {/* Tombol KELUAR */}
                      <Button
                        type="button"
                        variant="outline-secondary"
                        size="sm"
                        className="fw-semibold py-1 d-flex align-items-center justify-content-center gap-1"
                        style={{ fontSize: '0.74rem', borderRadius: '6px' }}
                        onClick={handleClosePendaftaranPoliModal}
                      >
                        <i className="bi bi-x-lg"></i>
                        <span>KELUAR</span>
                      </Button>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>
      {/* ══ MODAL INPUT ULANG / CETAK ULANG NJM ══ */}
      <Modal show={showUlangNjmModal} onHide={() => setShowUlangNjmModal(false)} centered size="sm">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', color: '#fff' }}>
          <Modal.Title style={{ fontSize: '0.88rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-arrow-counterclockwise text-warning"></i>
            <span>CETAK ULANG NJM</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3 bg-white">
          <Form onSubmit={handleConfirmUlangNjm}>
            <Form.Group className="mb-3">
              <Form.Label className="fw-semibold text-dark mb-1" style={{ fontSize: '0.75rem' }}>
                Masukkan Nomor NJM yang akan Dicetak Ulang:
              </Form.Label>
              <Form.Control
                type="text"
                size="sm"
                value={inputUlangNjm}
                onChange={e => setInputUlangNjm(e.target.value)}
                placeholder="Contoh: NJM-2026-0881"
                style={{ fontSize: '0.82rem', fontFamily: 'monospace', fontWeight: 'bold', color: '#92400e', background: '#fef3c7', borderColor: '#f59e0b' }}
                autoFocus
              />
              <Form.Text className="text-muted" style={{ fontSize: '0.68rem' }}>
                Nomor Nota Jasa Medis (NJM) akan diproses ke endpoint backend <strong>/cetak_njm</strong> untuk dicetak/dipreview.
              </Form.Text>
            </Form.Group>
            <div className="d-flex justify-content-end gap-2 border-top pt-2">
              <Button variant="light" size="sm" className="fw-semibold" style={{ fontSize: '0.75rem' }} onClick={() => setShowUlangNjmModal(false)}>
                Batal
              </Button>
              <Button type="submit" variant="warning" size="sm" className="fw-bold text-dark px-3" style={{ fontSize: '0.75rem', background: '#d97706', borderColor: '#d97706' }}>
                <i className="bi bi-printer-fill me-1"></i> Proses Cetak
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* ══ MODAL PREVIEW FILE PDF CETAK NJM (/cetak_njm) ══ */}
      <Modal show={showCetakNjmModal} onHide={() => setShowCetakNjmModal(false)} size="lg" centered backdrop="static">
        <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)', color: '#fff', borderBottom: '2px solid #0d9488' }}>
          <Modal.Title style={{ fontSize: '0.92rem', fontWeight: '700' }} className="d-flex align-items-center gap-2">
            <i className="bi bi-file-earmark-pdf-fill text-warning fs-5"></i>
            <span>PREVIEW DOKUMEN CETAK NOTA JASA MEDIS (NJM)</span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-3" style={{ background: '#f8fafc' }}>
          {isGeneratingNjmPdf ? (
            <div className="text-center py-5">
              <Spinner animation="border" variant="teal" style={{ width: '2.5rem', height: '2.5rem', color: '#0d9488' }} />
              <div className="fw-bold text-dark mt-3" style={{ fontSize: '0.9rem' }}>
                Sedang Menghubungkan ke Backend Endpoint <code style={{ color: '#0d9488' }}>/cetak_njm</code>...
              </div>
              <div className="text-muted" style={{ fontSize: '0.75rem' }}>
                Membuat dokumen PDF Nota Jasa Medis untuk Nomor: <strong>{formDataPoli.no_njm}</strong>
              </div>
            </div>
          ) : njmError ? (
            <div className="alert alert-danger p-3 my-2" style={{ fontSize: '0.8rem' }}>
              <i className="bi bi-exclamation-octagon-fill me-2 fs-5"></i>
              {njmError}
            </div>
          ) : (
            <div>
              {/* Card Ringkasan Informasi NJM */}
              <Card className="border shadow-sm mb-3" style={{ borderRadius: '10px', background: '#ffffff', borderColor: '#e2e8f0' }}>
                <Card.Body className="p-3">
                  <div className="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
                    <div>
                      <div className="text-muted text-uppercase" style={{ fontSize: '0.65rem' }}>Nomor Nota Jasa Medis (NJM)</div>
                      <div className="fw-bold font-monospace text-warning fs-5" style={{ color: '#d97706' }}>
                        {njmPdfData?.no_njm || formDataPoli.no_njm}
                      </div>
                    </div>
                    <Badge bg="teal" style={{ background: '#0d9488', fontSize: '0.75rem', padding: '0.4rem 0.75rem' }}>
                      <i className="bi bi-check-circle-fill me-1"></i> SIAP DICETAK
                    </Badge>
                  </div>
                  <Row className="g-2" style={{ fontSize: '0.76rem' }}>
                    <Col md={6}>
                      <div><span className="text-muted">Nama Pasien:</span> <strong>{njmPdfData?.nama_pasien || formDataPoli.nama}</strong></div>
                      <div><span className="text-muted">No. Medrec:</span> <strong className="font-monospace text-teal" style={{ color: '#0d9488' }}>{njmPdfData?.no_medrec || formDataPoli.no_medrec}</strong></div>
                    </Col>
                    <Col md={6}>
                      <div><span className="text-muted">Dokter DPJP:</span> <strong>{njmPdfData?.dokter_tujuan || formDataPoli.dokter_tujuan}</strong></div>
                      <div><span className="text-muted">Penjamin:</span> <strong>{njmPdfData?.penjamin || formDataPoli.penjamin_pasien}</strong></div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* PDF Preview Frame Container */}
              <div className="border rounded shadow-sm bg-white overflow-hidden mb-3" style={{ height: '380px', borderColor: '#cbd5e1' }}>
                {njmPdfData?.pdf_url || njmPdfData?.preview_url ? (
                  <iframe
                    id="njm-pdf-iframe"
                    title="NJM PDF Preview"
                    src={njmPdfData?.preview_url || njmPdfData?.pdf_url}
                    width="100%"
                    height="100%"
                    style={{ border: 'none' }}
                  />
                ) : (
                  <div className="d-flex flex-column align-items-center justify-content-center h-100 p-4 text-center">
                    <i className="bi bi-file-earmark-pdf text-teal display-4 mb-2" style={{ color: '#0d9488' }}></i>
                    <div className="fw-bold text-dark" style={{ fontSize: '0.88rem' }}>Dokumen Nota Jasa Medis (NJM) Siap Dicetak</div>
                    <div className="text-muted mb-3" style={{ fontSize: '0.74rem' }}>
                      Endpoint <code>/cetak_njm</code> berhasil merespon payload <code>{`{ "no_njm": "${formDataPoli.no_njm}" }`}</code>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="py-2 px-3 bg-white border-top justify-content-between" style={{ borderColor: '#e2e8f0' }}>
          <div>
            <Button
              variant="outline-primary"
              size="sm"
              className="fw-semibold me-2"
              style={{ fontSize: '0.78rem' }}
              href={njmPdfData?.download_url || '#'}
              download={`Cetak_NJM_${formDataPoli.no_njm}.pdf`}
              disabled={isGeneratingNjmPdf}
            >
              <i className="bi bi-download me-1"></i> Download PDF
            </Button>
          </div>
          <div className="d-flex gap-2">
            <Button
              variant="secondary"
              size="sm"
              className="fw-semibold"
              style={{ fontSize: '0.78rem' }}
              onClick={() => setShowCetakNjmModal(false)}
            >
              Tutup
            </Button>
            <Button
              variant="success"
              size="sm"
              className="fw-bold text-white px-3 shadow-sm"
              style={{ fontSize: '0.78rem', background: 'linear-gradient(135deg, #059669 0%, #10b981 100%)', border: 'none' }}
              onClick={handlePrintNjmIframe}
              disabled={isGeneratingNjmPdf}
            >
              <i className="bi bi-printer-fill me-1.5"></i> Cetak ke Printer
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

// ══════════════ STYLES ══════════════
const styles = {
  appContainer: {
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f8fafc 0%, #f1f5f9 40%, #e2e8f0 100%)',
    display: 'flex', flexDirection: 'column',
  },
  navbarCustom: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 60%, #0d9488 100%)',
    padding: '0.25rem 1rem', flexShrink: 0,
  },
  mainContent: {
    flex: 1, padding: '0.4rem', overflowY: 'auto',
  },
  mainCard: {
    borderRadius: '12px', border: '1.5px solid #cbd5e1',
    boxShadow: '0 8px 30px rgba(15, 23, 42, 0.06)',
    background: '#ffffff', overflow: 'hidden',
  },
  cardHeader: {
    padding: '0.4rem 0.75rem', color: '#ffffff', fontWeight: 600, fontSize: '0.83rem',
  },
  bgMenuHeader: {
    background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0d9488 100%)',
  },
};

export default PasienRJ;
